<template>
  <div class="request-form">
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <h4>Request a call back right now ?</h4>
          <span>Need expert advice? Request an immediate callback now.</span>
        </div>
        <div class="col-md-4">
          <router-link to="/contact" class="border-button"
            >Contact Us</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RequestCard",
};
</script>
